import { BigNumber } from '@0x/utils'
import { Asset, getCommon } from 'app-lib/assetUtils'
import React from 'react'
import NumberEasing from 'react-number-easing'
import ExternalLink from 'shared-components/ExternalLink'
import { Icon } from 'ui-framework'

interface IAssetBalanceProps {
  size?: 'small' | 'normal'
  variant: 'green' | ''
  className?: string
  balance: BigNumber
  link?: string
  tokenLogo?: React.ReactNode
  decimals?: number
  asset: Asset
}

function customFunctionRender(num: number) {
  return (num > -1 && num < -0.01) || (num >= 0.01 && num < 1)
    ? num.toPrecision(2)
    : Math.floor(num).toFixed()
}

export function AssetBalance(props: IAssetBalanceProps) {
  const { spriteLogo, displayName } = getCommon(props.asset)
  return (
    <div className="flex-row-center margin-bottom-1">
      <Icon name={spriteLogo} size={props.size === 'small' ? 24 : 32} className="margin-right-05" />
      {props.link ? (
        <ExternalLink className="link--discreet" href={props.link}>
          {displayName}
        </ExternalLink>
      ) : (
        <div className="txt-alternate">{displayName}</div>
      )}
      <span title={props.balance.toFixed(18, 1)} className="txt-title flex-row-end">
        <NumberEasing
          value={props.balance.toNumber()}
          customFunctionRender={customFunctionRender}
          ease="quintInOut"
        />
      </span>
    </div>
  )
}

AssetBalance.defaultProps = {
  variant: '',
  size: 'normal',
}

export default React.memo(AssetBalance)
